<script>
	export let value;
	export let min = false;
	export let max = false;

	function incrementValue(){
		if(!max || value + 1 <= max) value++;
		else value = max;
	}
	function decrementValue(){
		if(!min || value - 1 >= min) value--;
		else value = min;
	}
</script>
<div class='container'>
	<button class='year-selector' on:click|preventDefault>{value}</button>
	<div>
		<button class='arrows' on:click|preventDefault={incrementValue}>▲</button>
		<button class='arrows' on:click|preventDefault={decrementValue}>▼</button>
	</div>
</div>
<style>
.container{
	display: flex;
}

button.arrows{
	font-size:8px;
	height:16px;
	width:auto;
	display: block;
	margin:0 0 0 1px;
	border-bottom:none;
}
</style>